import { ProcessFilterGroups } from '@components/GalleryComponents/GalleryPageContent/GalleryPageContent';
import { FilterGroups } from '@components/GalleryComponents/GalleryPageContent/GalleryPageContentFiltering';
import { useCallback } from 'react';

const WEDDING_WEBSITE_PRODUCT_TYPE = 'Wedding Website';

const _getTemplateImageUrl = (filename: string, version: string = '1638397480'): string =>
  `https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/new-websites/${filename}.jpg?v=${version}`;

//For tags, refer to `eCardCategorySlugsToTagsMap` in `src/utils/gallery.util.ts`
const WEBSITE_TEMPLATE_GALLERY_CARDS: GalleryECard[] = [
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('emilio_mocha'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Brown', 'Rose Gold'],
    font: 'Dream Avenue',
    variantColor: null,
    variantName: null,
    variantThemeId: 'emilio_mocha',
    title: 'Emilio Mocha',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Emilio Mocha',
      themeId: 'emilio_mochaa',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('rosebed'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Bold', 'Modern'],
    colors: ['Black'],
    font: 'Gilda Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'rosebed',
    title: 'Rosebed',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Rosebed',
      themeId: 'rosebed',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },

  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('tiffany_red'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Red'],
    font: 'Allenoire',
    variantColor: null,
    variantName: null,
    variantThemeId: 'tiffany_red',
    title: 'Tiffany Red',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Tiffany Red',
      themeId: 'tiffany_red',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('queens_palace'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Classic', 'Bold'],
    colors: ['Blue', 'Gold'],
    font: 'Mozart Script',
    variantColor: null,
    variantName: null,
    variantThemeId: 'queens_palace',
    title: 'Queens Palace',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Queens Palace',
      themeId: 'queens_palace',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('newsstand_olive'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold', 'Seasonal'],
    colors: ['Green'],
    font: 'Losta Masta',
    variantColor: null,
    variantName: null,
    variantThemeId: 'newsstand_olive',
    title: 'Newsstand Olive',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Newsstand Olive',
      themeId: 'newsstand_olive',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('minimalist_arch'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Green', 'Yellow'],
    font: 'DM Serif Display',
    variantColor: null,
    variantName: null,
    variantThemeId: 'minimalist_arch',
    title: 'Minimalist Arch',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Minimalist Arch',
      themeId: 'minimalist_arch',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
  {
    variationType: 'brannan',
    imageUrl: _getTemplateImageUrl('editorial_lime'),
    printUrl: '',
    vendor: 'Joy',
    tags: ['Modern', 'Bold'],
    colors: ['Green', 'Yellow'],
    font: 'Casablanca',
    variantColor: null,
    variantName: null,
    variantThemeId: 'editorial_lime',
    title: 'Editorial Lime',
    productType: WEDDING_WEBSITE_PRODUCT_TYPE,
    theme: {
      name: 'Editorial Lime',
      themeId: 'editorial_lime',
      marketingData: [],
    },
    pdpConfig: {
      disableVariantSelection: true,
      disableWebsiteLayoutSelection: true,
      disableMatchingCardNote: true,
      disableProductMenu: true,
    },
    isComingSoon: true,
  },
];

const NEW_TEMPLATE_THEME_IDS = new Set(WEBSITE_TEMPLATE_GALLERY_CARDS.map((card) => card.theme.themeId));

function insertEveryNth(initialCards: MarketingData, cardsToInsert: MarketingData, interval: number, randomize?: boolean): MarketingData {
  const copiedCards = [...initialCards];
  const cards = randomize ? copiedCards.sort(() => Math.random() - 0.5) : copiedCards;
  let cardToInsertIndex = 0;
  let cardToInsert: GalleryECard | undefined = undefined;
  for (let i = 0; i < initialCards.length + Math.floor(initialCards.length / interval); i += interval) {
    cardToInsert = cardsToInsert[cardToInsertIndex++];
    if (!cardToInsert) {
      return cards;
    }
    cards.splice(i, 0, cardToInsert);
  }
  return cards;
}

export const insertNewTemplates = (initialCards: MarketingData): MarketingData => {
  return insertEveryNth(initialCards, WEBSITE_TEMPLATE_GALLERY_CARDS, 4, true);
};

export const processDesignFilterGroups: ProcessFilterGroups = (filterGroups, { hasFiltersApplied }): FilterGroups => {
  const { matchesWithNewTemplates, matchesWithoutNewTemplates } = filterGroups.match.reduce(
    (acc, card) => {
      acc[
        NEW_TEMPLATE_THEME_IDS.has(card.theme.themeId) && card.isComingSoon ? 'matchesWithNewTemplates' : 'matchesWithoutNewTemplates'
      ].push(card);
      return acc;
    },
    { matchesWithoutNewTemplates: [], matchesWithNewTemplates: [] } as {
      matchesWithoutNewTemplates: MarketingData;
      matchesWithNewTemplates: MarketingData;
    }
  );
  /**
   * When viewing save the date or invitation cards, prioritize joy printed themes
   */
  return {
    match: hasFiltersApplied
      ? insertEveryNth(matchesWithoutNewTemplates, matchesWithNewTemplates, 5, false)
      : insertEveryNth(filterGroups.match, WEBSITE_TEMPLATE_GALLERY_CARDS, 5, false),
    noMatch: filterGroups.noMatch,
  };
};
